import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import NotFound from '../NotFound';
import ListView from './ListView';

const ClassAttendancePage = ({ match: { path } }) => (
  <Switch>
    <Route exact path={path} component={ListView} />
    <Route component={NotFound} />
  </Switch>
);

ClassAttendancePage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default ClassAttendancePage;
